import { render, staticRenderFns } from "./CompletePhysicianProfileCheck.vue?vue&type=template&id=7a873cea"
import script from "./CompletePhysicianProfileCheck.vue?vue&type=script&lang=js"
export * from "./CompletePhysicianProfileCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports